import { CSSProperties } from "react";
import style from "./style.module.css";
import { TIMELINE_MIN_HEIGHT } from "lib/constants";

// Base bottom position. Also exposed to CSS via the
// --saving-indicator-base-bottom custom property below so both sides stay
// in sync when this value changes.
export const SAVING_INDICATOR_BASE_BOTTOM = 54;

interface SavingIndicatorProps {
  isDesignSaving: boolean;
  isTimelineVisible: boolean;
  timelineHeight?: number;
}

const SavingIndicator = ({
  isDesignSaving,
  isTimelineVisible,
  timelineHeight
}: SavingIndicatorProps) => {
  if (!isDesignSaving) return null;

  const inlineStyle: CSSProperties = {
    ["--saving-indicator-base-bottom" as string]: `${SAVING_INDICATOR_BASE_BOTTOM}px`
  };
  if (isTimelineVisible && timelineHeight) {
    inlineStyle.bottom = `${
      SAVING_INDICATOR_BASE_BOTTOM + (timelineHeight - TIMELINE_MIN_HEIGHT)
    }px`;
  }

  return (
    <div className={style.savingIndicator} style={inlineStyle}>
      Saving...
    </div>
  );
};

export default SavingIndicator;
